<template>
  <div class="friendLink">
    <div class="title">{{title}}</div>
    <div class="newKnow" v-if="type == 'know'">
      <ul>
        <li v-for="item in list" :key="item.time">
          <img :src="item.imgSrc">
          <div class="what">
            <p>{{item.title}}</p>
            <span>{{item.time}}</span>
          </div>
        </li>
      </ul>
    </div>
    <div class="link" v-if="type == 'link'">
      <div class="link_item" v-for="item in list" :key="item.title">
        <img :src="item.imgSrc">
        <p>{{item.title}}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    listArr: {
      type: Array
    },
    type: {
      type: String
    },
    title: {
      type: String
    }
  },
  data () {
    return {
      list: this.listArr
    }
  }
}
</script>
<style lang="stylus" scoped>
.title
  width 100%
  height 50px
  background-color #F8F8F8
  font-size 20px
  font-weight bold
  text-align center
  line-height 50px
.newKnow
  li
    margin 20px 0
    display flex
    justify-content space-between
    img
      width 40%
      height 70px
    .what
      display inline-block
      height 70px
      position relative
      >p
        font-size 18px
        font-weight bold
      >span
        position absolute
        bottom 0
        right 0
.link
  display flex
  justify-content space-between
  flex-wrap wrap
  margin-top 20px
  .link_item
    width 40%
    img
      height 70px
    p
      font-size 15px
      font-weight bold
      margin 10px
      text-align center
</style>
